import { Box, Text } from "@chakra-ui/react";
import { Player } from "@/types";
import { RankingCard } from "./RankingCard";

interface Props {
  players: Player[];
}

export function RankingList({ players }: Props) {
  if (players.length === 0) {
    return (
      <Box
        bg="white"
        rounded="xl"
        p={8}
        textAlign="center"
        color="gray.500"
      >
        <Text>該当するプレイヤーが見つかりません</Text>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {players.map((player, index) => (
        <RankingCard
          key={player.player_id}
          player={player}
          rank={index + 1}
        />
      ))}
    </Box>
  );
}
